<div class="multiple-filter-wrapper" #multiDropdownContainer>
  <div class="multiple-filter-body" [ngStyle]="{ 'max-height': scrollHeight }">
    <!-- start select All checkbox  -->
    <div class="data-list-filter" *ngIf="isSelectAll && data?.length > 0" (click)="isAllSelected()">
      <div class="check" [ngClass]="{'custom-checkbox-gray': grayCheckbox}">
        <app-checkbox [isChecked]="masterSelected"></app-checkbox>
      </div>
      <div class="name">
        <div class="name-max" [ngClass]="{ 'width-100p': type !== 'tag', 'width-85p': type === 'tag' }">
          {{isTextCompany ? 'Company' : 'Select All'}} 
        </div>
      </div>
    </div>

    <!-- Search and select list -->
    <div class="" *ngIf="isSearchSelect">
      <div class="d-flex py-2 px-2 font-13 font-600">
        <div class="d-flex pr-2">
          <span class="hover-underline" (click)="searchSelectAll()">Select all {{listData.length}}</span>
        </div>
        <span>-</span>
        <span class="hover-underline pl-2" (click)="searchClear()">Clear</span>
      </div>
      <div class="pl-1 pr-1 pt-2 pb-2">
        <app-input  [placeholder]="multipleSearchPlaceholders?.searchPlaceolder" [value]="query" styleClassInput="width-100p" theme="border"
        (appChange)="onSearchSupplier($event)"
        [maxLength]="50">
       </app-input>
      </div>
      <div class="divider"  *ngIf="(selectedData.length > 0 && listData.length > 0) && isSearching"></div>

      <div class="flex-start-start font-bold font-black mt-2 mb-1 ml-2" *ngIf="(selectedData.length > 0 && listData.length > 0) && isSearching">
        Selected
      </div>
      <div *ngFor="let obj of listData; let i = index" [hidden]="!obj.isChecked" class="data-list-filter"
        [ngClass]="{'bg-gray font-bold': obj.isHeader || obj?.isMakeBold}" (click)="onOptionClick(obj, i)">
        <div  class="check"
        [ngClass]="{'custom-checkbox-gray': grayCheckbox, 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj)}">
        <app-checkbox [isChecked]="obj.isChecked"></app-checkbox>
      </div>

      <div class="name" [ngClass]="{ 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj) }">
        <div class="name-max" [ngClass]="{ 'width-100p': type !== 'tag', 'width-85p': type === 'tag' }"
          [pTooltip]="obj[nameField]" tooltipPosition="top">
          {{obj[nameField]}}
        </div>
        <div class="tag-circle" *ngIf="type === 'tag'" [ngStyle]="{ backgroundColor: obj?.color }">
          &nbsp;
        </div>
      </div>
    </div>

    <div class="flex-start-start font-bold font-black mt-2 mb-1 ml-2" *ngIf="selectedData.length > 0 && listData.length > 0 && isSearching">{{multipleSearchPlaceholders?.allListPlaceholder}}</div>
    <div class="divider mt-2"  *ngIf="(selectedData.length > 0 && listData.length > 0) && isSearching"></div>
      <div *ngFor="let obj of listData; let i = index" class="data-list-filter"  [hidden]="obj.isChecked"
        [ngClass]="{'bg-gray font-bold': obj.isHeader || obj?.isMakeBold}" (click)="onOptionClick(obj, i)">
        <div class="check"
          [ngClass]="{'custom-checkbox-gray': grayCheckbox, 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj)}">
          <app-checkbox [isChecked]="obj.isChecked"></app-checkbox>
        </div>

        <div class="name" [ngClass]="{ 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj) }">
          <div class="name-max" [ngClass]="{ 'width-100p': type !== 'tag', 'width-85p': type === 'tag' }"
            [pTooltip]="obj[nameField]" tooltipPosition="top">
            {{obj[nameField]}}
          </div>
          <div class="tag-circle" *ngIf="type === 'tag'" [ngStyle]="{ backgroundColor: obj?.color }">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <!-- end select All checkbox  -->
    <span *ngIf="!isSearchSelect">
      <div *ngFor="let obj of data; let i = index" class="data-list-filter" 
      [ngClass]="{'bg-gray font-bold': obj.isHeader || obj?.isMakeBold, 'bg-gray': obj?.isInActive}" (click)="onOptionClick(obj)">
      <div class="check"
        [ngClass]="{'custom-checkbox-gray': grayCheckbox, 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj)}">
        <app-checkbox [isChecked]="obj.isChecked"></app-checkbox>
      </div>

      <div class="name" [ngClass]="{ 'border-0': viewChildData(obj), 'child-data': viewMarketingTrial(obj) }">
        <div class="name-max" [ngClass]="{ 'width-100p': type !== 'tag', 'width-85p capitalize flex-start-start': type === 'tag' }"
          [pTooltip]="obj[nameField]" tooltipPosition="top">
          {{obj[nameField]}}
          <div class="tag-circle flex-center-center bg-primary font-10 m-0 ml-2" *ngIf="obj[countField]">{{obj[countField]}}</div>
        </div>
        <div class="tag-circle" *ngIf="type === 'tag'" [ngStyle]="{ backgroundColor: obj?.color }">
          &nbsp;
        </div>
      </div>
    </div>
    </span>
  </div>
</div>
